// extracted by mini-css-extract-plugin
module.exports = {"extra-small":"only screen and (min-width: 375px)","extraSmall":"only screen and (min-width: 375px)","svg":"_3dO4t"};